import {Component} from '@angular/core';
import {SubMenuOption} from '../types/submenu-option';

@Component({
  selector: 'stock-sub-menu',
  template: `<sub-menu [options]="subMenu"></sub-menu>`,
})


export class StockSubMenuComponent {
  subMenu: SubMenuOption[];

  constructor() {
    this.subMenu = [
      {route: '/stock/summary', title: 'Stock Summary'},
      {route: '/stock/all', title: 'All Stock'},
      {route: '/stock/install_upload', title: 'Install Upload'},
      {route: '/stock/installations', title: 'Installations'},
    ];
  }
}
